import { Link } from "react-router-dom";
import { BrandLogo } from "@/components/Navbar";

const LINKS = { "Website Audit": "/audit", "SEO": "/seo", "Pricing": "/pricing", "Platform": "/platform" };
const COLS = [
  { title: "Build", items: ["New Website", "AI Website", "Ecommerce", "Web Applications", "Redesign"] },
  { title: "Improve", items: ["Website Audit", "SEO", "Performance", "Accessibility", "Conversion"] },
  { title: "AI", items: ["AI Assistants", "AI Content", "AI Search", "AI Analytics", "Automation"] },
  { title: "Company", items: ["Platform", "About", "Portfolio", "Pricing", "Contact"] },
];

export default function Footer() {
  return (
    <footer className="relative z-10 border-t border-slate-200 bg-slate-50" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-2 md:grid-cols-6 gap-10">
          <div className="col-span-2">
            <BrandLogo size={40} />
            <p className="text-slate-500 text-sm max-w-xs leading-relaxed mt-5">
              We build and modernize websites into intelligent business platforms with AI, SEO,
              analytics and automation.
            </p>
            <p className="overline mt-6">Build • Modernize • Automate • Measure • Grow</p>
          </div>
          {COLS.map((col) => (
            <div key={col.title}>
              <p className="font-heading font-bold text-sm text-slate-900 mb-4">{col.title}</p>
              <ul className="space-y-2.5">
                {col.items.map((i) => (
                  <li key={i}>
                    {LINKS[i] ? (
                      <Link to={LINKS[i]} className="text-sm text-slate-500 hover:text-brand transition-colors">{i}</Link>
                    ) : (
                      <span className="text-sm text-slate-500 hover:text-brand transition-colors cursor-pointer">{i}</span>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-14 pt-8 border-t border-slate-200 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-slate-400 text-xs">© {new Date().getFullYear()} WebsiteTech.pro — Website Development Without Borders.</p>
          <div className="flex items-center gap-6 text-xs text-slate-400">
            <span className="hover:text-brand transition-colors cursor-pointer">Privacy</span>
            <span className="hover:text-brand transition-colors cursor-pointer">Terms</span>
            <Link to="/admin" className="hover:text-brand transition-colors">Admin</Link>
          </div>
        </div>
        {/* SocialPulse Network attribution — moved from the top of every page
            to a slim footer line so it no longer competes with the primary CTA
            (audit remediation). */}
        <div className="mt-6 pt-6 border-t border-slate-100 flex items-center justify-center">
          <a
            href="https://socialpulse.com"
            target="_blank"
            rel="noreferrer"
            data-testid="socialpulse-network-footer"
            className="inline-flex items-center gap-1.5 text-[11px] text-slate-400 hover:text-slate-600 transition-colors"
          >
            <span>Part of the</span>
            <span className="font-bold bg-gradient-to-r from-fuchsia-500 via-pink-500 to-orange-500 bg-clip-text text-transparent">
              SocialPulse Network
            </span>
            <span className="opacity-70">— visit SocialPulse.com →</span>
          </a>
        </div>
      </div>
    </footer>
  );
}
